import { useEffect, useState } from 'react';
import { currencyCode } from '../../utils/currency';
import {
  finalizeDepositInput,
  formatDepositDisplay,
  normalizeDepositInput,
} from '../../utils/responsibleLimits';

export default function MobileResponsibleDepositInput({
  value,
  disabled,
  onChange,
}) {
  const [focused, setFocused] = useState(false);
  const [displayValue, setDisplayValue] = useState(() => formatDepositDisplay(value));

  useEffect(() => {
    if (!focused) {
      setDisplayValue(formatDepositDisplay(value));
    }
  }, [value, focused]);

  const filled = Boolean(displayValue);

  return (
    <div className="mobile-responsible-limit__input-wrap">
      <div className="inputContainer inputContainer_medium">
        <div
          className={[
            'inputLine',
            'inputLine_leftOffset',
            'inputLine_rightOffset',
            'inputLine_withoutBottomOffset',
            filled ? 'inputLine_filled' : '',
            focused ? 'is-focused' : '',
          ].filter(Boolean).join(' ')}
        >
          <div className="inputLine__content">
            <input
              type="text"
              className="input"
              inputMode="decimal"
              value={displayValue}
              disabled={disabled}
              onFocus={() => setFocused(true)}
              onBlur={() => {
                setFocused(false);
                const finalized = finalizeDepositInput(displayValue);
                setDisplayValue(finalized);
                onChange(finalized);
              }}
              onChange={(event) => {
                const next = normalizeDepositInput(event.target.value);
                setDisplayValue(next);
                onChange(next);
              }}
              autoComplete="off"
            />
          </div>
          <span className="mobile-responsible-limit__suffix">{currencyCode()}</span>
        </div>
      </div>
    </div>
  );
}
